import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import withAuthentication from 'components/withAuthentication';
import LoginPage from '../LoginPage';
import LoadingPage from 'pages/LoadingPage';

const QFFRoute = ({
  component: Component,
  isSSO,
  isAuthenticating,
  isAuthenticatedWithSSO,
  hasInitializedSSO,
  setAuthToSSO,
  ...routeProps
}) => {
  useEffect(() => {
    setAuthToSSO();
  }, [setAuthToSSO]);

  if (isAuthenticating) {
    return <LoadingPage />;
  }

  return (
    <Route
      {...routeProps}
      render={(props) =>
        isAuthenticatedWithSSO ? (
          <Component {...props} isSSO={isSSO} />
        ) : (
          <LoginPage data-testid="login-form" isSSO={true} hasInitializedSSO={hasInitializedSSO} />
        )
      }
    />
  );
};

export default withAuthentication(QFFRoute);
